import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import { Row, Col, Card, Button } from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import { pageConfig } from "../configure/page";
import "./sgn.style.css";
import "../chat/styles.css";
import { useAuth } from "../../components/msalAuth/AuthProvider";
import { getText } from "../configure/utils";
import ReRegisMFA from "../chat/re_regis_MFA";
import UnlockResetAD from "../chat/UnlockResetAD";
import Ariba from "../chat/Ariba";
import mfaicon from "../../assets/signon/mfa.png";

export default function SignOnchat() {
  const { language } = useContext(LanguageContext);
  const { login } = useAuth();
  const { getSignOnChat } = pageConfig();

  const [isHovered, setIsHovered] = useState(false);
  // const [isLoadingScreen, setIsLoadingScreen] = useState(false);
  const [isADChatOpen, setIsADChatOpen] = useState(false);
  const [showMFAChat, setShowMFAChat] = useState(false);
  const [isAribaChatOpen, setIsAribaChatOpen] = useState(false);

  const currentLanguageRef = useRef(language);
  const errorMsg = useRef("");

  useEffect(() => {
    currentLanguageRef.current = language;
    errorMsg.current = getText("sandee.error");
  }, [language]);

  const menuADClick = useCallback(() => {
    if (isADChatOpen) {
      const dfMessengerBubble = document.querySelector(".adUnlockReset df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-ad-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    } else {
      setIsADChatOpen(true);
      setShowMFAChat(false);
      setIsAribaChatOpen(false);
    }
  }, [isADChatOpen, setIsADChatOpen]);

  // ฟังก์ชันเปิด/แสดง chat หรือสั่งเปิด bubble ถ้าเปิดอยู่แล้ว
  const onClickReRegisterMFA = useCallback(() => {
    if (showMFAChat) {
      const dfMessengerBubble = document.querySelector(".mfaResetChat df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-mfa-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    } else {
      setIsADChatOpen(false);
      setShowMFAChat(true);
      setIsAribaChatOpen(false);
    }
  }, [showMFAChat, setShowMFAChat]);

  const menuAribaClick = useCallback(() => {
    if (isAribaChatOpen) {
      const dfMessengerBubble = document.querySelector(".ariba df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-ariba-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    } else {
      setIsADChatOpen(false);
      setShowMFAChat(false);
      setIsAribaChatOpen(true);
    }
  }, [isAribaChatOpen, setIsAribaChatOpen]);

  const handleLogin = () => {
    login();
  };

  const [hoveredButton, setHoveredButton] = useState(null);

  return (
    <div className="sgn-menu-section" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <Card className={`sgn-menu-card ${isHovered ? "sgn-card-hovered" : ""}`}>
        <div className="sandee-text-head-title">
          <span>SANDEE</span>
        </div>
        <Row gutter={[16, 32]} className="sgn-row-chat">
          {getSignOnChat(language).map((chatItem, index) => {
            const isFirstButton = chatItem.onClick === "handleLogin";
            const isSecondButton = chatItem.onClick === "menuADClick";

            const onClickHandler =
              chatItem.onClick === "handleLogin"
                ? handleLogin
                : chatItem.onClick === "menuADClick"
                ? menuADClick
                : chatItem.onClick === "menuAribaClick"
                ? menuAribaClick
                : chatItem.onClick === "onClickReRegisterMFA"
                ? onClickReRegisterMFA
                : null;

            return (
              <Col
                key={index}
                xs={isFirstButton || isSecondButton ? 24 : 12}
                sm={isFirstButton || isSecondButton ? 24 : 12}
                md={isFirstButton || isSecondButton ? 24 : 12}
                lg={isFirstButton || isSecondButton ? 24 : 12}
                xl={isFirstButton || isSecondButton ? 24 : 12}
              >
                <div
                  className={`sgn-button-wrapper ${isFirstButton || isSecondButton ? "" : "same-size-wrapper"}`}
                  style={{ display: "flex", alignItems: "center" }}
                  onMouseEnter={() => setHoveredButton(index)}
                  onMouseLeave={() => setHoveredButton(null)}
                >
                  <Button
                    type="primary"
                    onClick={onClickHandler}
                    className={`sgn-chat-button ${isFirstButton ? "sgn-chat-button-first" : isSecondButton ? "sgn-chat-button-second" : ""} ${
                      chatItem.buttonClass
                    }`}
                    icon={
                      isFirstButton || isSecondButton ? (
                        <img
                          src={hoveredButton === index ? chatItem.hoverImageSrc : chatItem.imageSrc}
                          alt={`icon ${chatItem.buttonClass}`}
                          className="sgn-button-icon"
                        />
                      ) : null
                    }
                    value={chatItem.buttonValue}
                  >
                    {isFirstButton || isSecondButton ? (
                      <span>{chatItem.buttonText}</span>
                    ) : (
                      <div
                        className="other-button"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={hoveredButton === index ? chatItem.hoverImageSrc : chatItem.imageSrc}
                          alt={`icon ${chatItem.buttonClass}`}
                          className="sgn-button-icon"
                          style={{ marginBottom: "0px" }}
                        />
                        <span>{chatItem.buttonText}</span>
                      </div>
                    )}
                  </Button>
                </div>
              </Col>
            );
          })}
        </Row>
      </Card>

      {/* ✅ กล่อง MFA */}
      {showMFAChat && <ReRegisMFA />}
      {isADChatOpen && <UnlockResetAD />}
      {isAribaChatOpen && <Ariba />}
    </div>
  );
}
